<template>
  <div class="mb-2">
    <div class="label mt-3 mb-1">Priority</div>

    <div class="btn-group d-flex align-items-center" role="group">
      <button
        type="button"
        class="btn btn-xs"
        v-bind:class="{
          'btn-primary': item.priority === priority.Normal,
          'btn-outline-primary': item.priority !== priority.Normal,
        }"
        v-on:click="updatePriority(priority.Normal)"
      >
        {{ priority.Normal }}
      </button>
      <button
        type="button"
        class="btn btn-xs"
        v-bind:class="{
          'btn-danger': item.priority === priority.High,
          'btn-outline-danger': item.priority !== priority.High,
        }"
        v-on:click="updatePriority(priority.High)"
      >
        {{ priority.High }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import Component from "vue-class-component";
  import { Prop } from "vue-property-decorator";
  import {
    IBoardItemDto,
    BoardItemPriorityDto,
  } from "@/apiclient/apiclient_generated";

  @Component({})
  export default class BoardItemPriority extends Vue {
    @Prop()
    item: IBoardItemDto;
    private priority = BoardItemPriorityDto;

    updatePriority(newPriority: BoardItemPriorityDto) {
      if (this.item.priority !== newPriority) {
        this.$emit("priorityUpdates", newPriority);
      }
    }
  }
</script>

<style scoped lang="scss">
  .btn-group {
    button {
      flex: 1 1 0;
    }
  }
</style>
